import { db } from "../../server";
import { instance } from "../apiclient";
import { interpolate } from "../helpers/stringHelper";
import { paths } from "../constants/dbPaths";
import { DetectBrand } from "../../mixins/brandDetector";

import { auth } from "../../server/index.js";
import { Cookie } from "../../api/helpers/cookieHelper";
import store from "../../store";
import { AppConfig } from "./../../../AppConfig.js";
import { onlineOrdering } from "@/constants/strings";
import { createCustomer, createPaymentMethod, getCards } from "../payment/DefaultPaymentHandler";

export function getDBUser(id) {
  return db.doc(interpolate(paths.UserDoc, id));
}
export function updateUser(id, data) {
  return db.doc(interpolate(paths.UserDoc, id)).set(data, {
    merge: true,
  });
}

export async function saveCreditCard(card, stripe, userId, storeID, customerID, user) {
  const res = {
    data: {
      Success: false,
      Message: '',
    }
  }
  let savedCards = [];
  if (customerID) {
    savedCards = (await getCards(customerID, storeID)).cards;
  }
  const resp = await createPaymentMethod(card, stripe, user.Email, user.Firstname);
  if (resp.paymentMethodID) {
    let newPaymentID = true;
    if (savedCards.length) {
      savedCards.forEach(saveCard => {
        if (saveCard.card.last4 === resp.card.last4) {
          newPaymentID = false;
        }
      });
    }
    if (newPaymentID) {
      const newID = await  createCustomer(user.Email, resp.paymentMethodID, customerID, storeID);
      if (newID) await updateUser(newID, userId);
    }
    res.data.Success = true;
  } else {
    res.data.Message = resp.ex;
  }
  return res;
}

export async function storeCard(userId, card, hqCompanyID, errorhandler) {
  let md = {
    HQCompanyID: hqCompanyID, //"2016949",
    CardHolder: card.holder,
    CardNumber: card.number,
    ExpiryYear: card.expYear,
    ExpiryMonth: card.expMonth,
    Cvv: card.cvc,
    ForceUseSandboxPayment: AppConfig.ForceUseSandboxPayment == "true",
  };
  return instance.post("customers/" + userId + "/storecard", md).catch((e) => {
    if (errorhandler) errorhandler(e.message);
  });
}
export async function storeCheckoutCard(userId, card, hqCompanyID) {
  try {
    let md = {
      HQCompanyID: hqCompanyID, //"2016949",
      CardHolder: card.CardHolder,
      CardNumber: card.CardNumber,
      ExpiryYear: card.ExpiryYear,
      ExpiryMonth: card.ExpiryMonth,
      Cvv: card.Cvv,
      ForceUseSandboxPayment: AppConfig.ForceUseSandboxPayment == "true",
    };
    return await instance.post("customers/" + userId + "/storecard", md);
  } catch (error) {
    console.log(error);
  }
}
export function deleteCard(userId, cardIdentifier, hqCompanyID) {
  return instance.delete(
    "customers/" + userId + "/storecard/" + cardIdentifier,
    {
      data: {
        userId: userId,
        cardIdentifier: cardIdentifier,
        HQCompanyID: hqCompanyID,
      },
    }
  );
}
export function OrderCount(userId) {
  return db.collection(interpolate(paths.HistoryOrdersCollection, userId));
}

export function getOrders(userId, StoreID) {
  var isBranded = DetectBrand.methods.isBranded();
  if (isBranded) {
    return db
      .collection(interpolate(paths.HistoryOrdersCollection, userId))
      .orderBy("ScheduledTime", "desc")
      .orderBy("CreatedOn", "desc");
  } else {
    return db
      .collection(interpolate(paths.HistoryOrdersCollection, StoreID))
      .where("OnlineOrderUserIdentifier", "==", userId)
      .orderBy("ScheduledTime", "desc")
      .orderBy("CreatedOn", "desc");
  }
}

export function getTrackingOrders(userId, StoreID) {
  var isBranded = DetectBrand.methods.isBranded();
  if (isBranded) {
    return db
      .collection(interpolate(paths.TrackingOrderCollection, userId))
      .orderBy("CreatedOn", "desc");
  } else {
    return db
      .collection(interpolate(paths.TrackingOrderCollection, StoreID))
      .where("OnlineOrderUserIdentifier", "==", userId)
      .orderBy("CreatedOn", "desc");
  }
}

export function getOrdersLoyalty(userId, StoreID) {
  var isBranded = DetectBrand.methods.isBranded();
  if (isBranded) {
    return db
      .collection(interpolate(paths.HistoryOrdersCollection, userId))
      .where("RewardPoints", ">=", 0)
      .orderBy("RewardPoints", "desc")
      .orderBy("CreatedOn", "desc");
  } else {
    return db
      .collection(interpolate(paths.HistoryOrdersCollection, StoreID))
      .where("OnlineOrderUserIdentifier", "==", userId)
      .where("RewardPoints", ">=", 0)
      .orderBy("RewardPoints", "desc")
      .orderBy("CreatedOn", "desc");
  }
}
export async function UpdateCustomer(udid, userInfo) {
  const customer = {
    Mobile: userInfo.Mobile || userInfo.PhoneNumber,
    DateOfBirth: userInfo.BirthDate,
    Address: userInfo.Address,
    DisplayName: userInfo.FirstName + " " + userInfo.LastName,
    Email: userInfo.Email,
    HQCompanyID: userInfo.HQCompanyID,
    Postcode: userInfo.Postcode,
    State: userInfo.State,
    FirstName: userInfo.FirstName,
    LastName: userInfo.LastName,
    Source: onlineOrdering,
  };
  return instance.post("/customers/" + udid, customer);
}

export async function CreateSoUser(userInfo) {
  const customer = {
    UserID: userInfo.userID,
    Mobile: userInfo.Mobile,
    Gender: userInfo.Gender,
    DateOfBirth: userInfo.BirthDate,
    FirstName: userInfo.FirstName,
    LastName: userInfo.LastName,
    DisplayName: userInfo.FirstName + " " + userInfo.LastName,
    Email: userInfo.Email,
    HQCompanyID: userInfo.HQCompanyID,
    Postcode: userInfo.Postcode,
    PreferredStore: userInfo.PreferredStore,
  };
  return instance.post("/customers/create-so-user", customer);
}

export async function signInWithPassword(email, password) {
  return auth.signInWithEmailAndPassword(email, password);
}
export async function signOut() {
  return auth.signOut();
}
export async function getGuestUser(StoreID, guestUserId) {
  var isBranded = DetectBrand.methods.isBranded();
  if (!isBranded) {
    return db.collection(paths.GuestUserDoc).doc(guestUserId).get();
  } else {
    return db
      .collection(interpolate(paths.GuestUserDoc, StoreID))
      .doc(guestUserId)
      .get();
  }
}
export async function sendResetPasswordLink(email, storeId) {
  const resetPasswordInfo = {
    Email: email,
    Company_ID: storeId,
  };
  return instance.post("/customers/reset-password-api", resetPasswordInfo);
}
export async function resetUserPassword(userDoc) {
  return await auth.currentUser.updatePassword(userDoc.Password);
}

export async function userIsExist(email) {
  return auth.fetchSignInMethodsForEmail(email);
}

export function RegisterVisit(udid, visitInfo) {
  const customer = {
    Name: visitInfo.Name,
    Email: visitInfo.Email,
    HQCompanyID: visitInfo.HQCompanyID,
    Phone: visitInfo.Phone,
    Table: visitInfo.Table,
    AgreeToReceivePromotionalOffers: visitInfo.AgreeToReceivePromotionalOffers,
  };
  return instance.post("/customers/register-visit/" + udid, customer);
}
export async function userExistsWithPhoneNumber(mobile) {
  if (DetectBrand.methods.isBranded()) {
    //backward compatibility
    const numbers = [];
    numbers.push(mobile);
    if (mobile.startsWith("0")) {
      numbers.push(mobile.substring(1));
    }
    if (mobile.startsWith("+")) {
      numbers.push(mobile.substring(3));
    }
    const users = await db
      .collection(paths.Users)
      .where("Mobile", "in", numbers)
      // .where("isVerified", "==", true)
      .limit(1)
      .get();
    return !users.empty;
  }

  let query = await db
    .collection(paths.Users)
    .where("Mobile", "==", mobile)
    .where("isVerified", "==", true)
    .limit(1)
    .get();
  return !query.empty;
}
/**
 * The first user whose `field` equals `value`. A query on Users is a Firestore list, and the security rules allow a
 * list only with limit 1: keep the limit.
 */
function firstUserWhere(field, value) {
  return db
    .collection(paths.Users)
    .where(field, "==", value)
    .limit(1)
    .get();
}
export async function getUserByPhoneNumber(mobile) {
  const users = await firstUserWhere("Mobile", mobile);
  if (!users.empty) {
    return users.docs[0].data();
  }
  return null;
}
export async function userExistsWithEmail(email) {
  let query = await firstUserWhere("Email", email);
  return !query.empty;
}
export async function isUserPhoneVerified() {
  let user = store.getters.user;
  // let userCookie = Cookie.getCookie(user.email);
  // if (userCookie) return true;
  let res = await getDBUser(user.id).get();
  let dbUser = res.data();
  if (dbUser && dbUser.isVerified) {
    Cookie.setCookie(user.email, JSON.stringify(user));
    return true;
  }
  return false;
}
export async function verifyUserPhone(user) {
  if (!user) return;
  Cookie.setCookie(user.email, JSON.stringify(user));
  await getDBUser(user.id).set({ isVerified: true }, { merge: true });
}
export async function unverifyUserPhone(user) {
  Cookie.setCookie(user.email, JSON.stringify(user), 0);
  await getDBUser(user.id).set({ isVerified: false }, { merge: true });
}
export async function getUserSms(user) {
  let res = await getDBUser(user.id).get();
  return res.data().SMSCode;
}
export function sendSmsVerification() {
  let user = store.getters.user;
  return new Promise(async (resolve, reject) => {
    try {
      let res = await instance.post(
        "/customers/verification/generate-sms-code",
        {
          userID: user.id,
          storeID: store.getters.currentStoreDoc.ID,
        }
      );
      if (res.data.success) {
        resolve(res.data.message);
      } else {
        reject(res.data.message);
      }
    } catch (error) {
      reject(error);
    }
  });
}

export async function UpdateCustomerPhone(user, number) {
  let duser = store.getters.dbuser;
  const customer = {
    ...duser,
    Mobile: number,
    HQCompanyID: user.HQCompanyID,
  };
  return await instance.post("/customers/" + user.id, customer);
}
export async function getLoyaltyMember(hqCompanyID, mobile, email) {
  const customer = {
    storeId: hqCompanyID,
    mobile: mobile,
    email: email,
  };
  const res = await instance.post("/members/getloyaltymember", customer);
  if (res.data.Success) {
    return {
      RewardPoints: res.data.Member.points,
      EarnedRewardPoints: res.data.Member.points + res.data.Member.spent,
      SpentRewardPoints: res.data.Member.spent,
      CustomerMemberCode: res.data.Member.memberCode,
    };
  }
  return null;
}

export function userBuilder(userObject) {
  if (!userObject) return null;
  return {
    uid: userObject.uid,
    id: userObject.uid,
    customerMemberCode: userObject.CustomerMemberCode,
    dateOfBirth: userObject.DateOfBirth,
    displayName: userObject.DisplayName,
    name: userObject.DisplayName,
    earnedRewardPoints: userObject.EarnedRewardPoints,
    email: userObject.Email,
    firebaseUDID: userObject.FirebaseUDID,
    firstName: userObject.FirstName,
    gender: userObject.Gender,
    isNewUser: userObject.IsNewUser,
    lastName: userObject.LastName,
    mobile: userObject.Mobile,
    postcode: userObject.Postcode,
    preferredStore: userObject.PreferredStore,
    rewardPoints: userObject.RewardPoints,
    state: userObject.State,
  };
}

export function getTrackingOrdersByMinutes(userId, storeID, minutesAgo) {
  var isBranded = DetectBrand.methods.isBranded();
  if (isBranded) {
    return db
      .collection(interpolate(paths.TrackingOrderCollection, userId))
      .where('CreatedOn', '>=', minutesAgo)
  } else {
    return db
      .collection(interpolate(paths.TrackingOrderCollection, storeID))
      .where('CreatedOn', '>=', minutesAgo)
  }
}
